module.exports = __webpack_public_path__ + "files/3f1caafd2160a93b4fa256214b87d0a2.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lora-bold-webfont.ttf
 ** module id = 933
 ** module chunks = 0
 **/